<template>
  <div v-if="isOpenProva">
    <div>
      <p>Prova Teórica</p>
      <iframe
        id="Provas"
        :src="linkProva"
        width="100%"
        height="600px!important"
      />
      <v-btn color="primary" block @click="closeProva">
        Sair
      </v-btn>
    </div>
  </div>

  <div v-else-if="live">
    <v-dialog v-if="showModal" v-model="showModal" max-width="600" max-height="200">
      <coleta-biometria :tempObjMeet="tempObjMeet" :choosedGesture="choosedGesture" :momento-atual="momento" />
    </v-dialog>
    <LiveChat
      :linkMeet="linkMeet"
      :tempObjMeet="tempObjMeet"
      :domain="jitsiDomain"
      :jitsiExternalScript="jitsiExternalScript"
      :jwt="jitsiJWT"
    />
    <v-btn
      color="red"
      style="
        z-index: 110;
        color: #fff"
      block
      @click="closeLive"
    >
      <v-icon style="transform: rotate(134deg); margin-right: 10px">
        phone
      </v-icon>
      Sair
    </v-btn>
  </div>

  <div v-else>
    <v-dialog v-if="showModal" v-model="showModal" max-width="600" max-height="200">
      <coleta-biometria :tempObjMeet="tempObjMeet" :choosedGesture="choosedGesture" :momento-atual="momento" />
    </v-dialog>

    <v-card style="background: aliceblue">
      <v-dialog v-if="showModalCheck" v-model="showModalCheck" max-width="800">
        <CheckList style="padding: 0;" />
      </v-dialog>
    </v-card>
    <v-btn
      fab
      fixed
      right
      bottom
      style="bottom: 8.5%; right: 4.5%"
      color="blue lighten-1"
      :loading="loading"
      @click="update"
    >
      <v-icon
        color="white"
      >
        update
      </v-icon>
    </v-btn>
    <label> Filtrar aulas por status: </label>
    <v-select
      v-model="selectedStatus"
      item-text="value"
      :items="status"
      type="number"
      label=""
      chips
      multiple
      dense
    >
      <template #selection="{ item }">
        <v-chip :color="getColor(item.status)" text-color="white">
          {{ item.value }}
        </v-chip>
      </template>
    </v-select>
    <v-data-table
      :items-per-page="20"
      :loading="loading"
      :headers="headers"
      :items="agendaAulas"
      :search="search"
      style="box-shadow: none;"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ getStatus(item.status) }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-chip
          color="green" dark
          :disabled="((item.status != '5' && item.status != '4') || closedAula == true) && !isCurrentClass(item.id)"
          @click="showImageModal(item)"
        >
          Entrar
        </v-chip>
      </template>
      <template v-slot:[`item.provas`]="{ item }">
        <v-icon
          small
          color="teal"
          :disabled="(item.status !== '5' || !isProva(item.link_meet) || isBlocked(item))"
          @click="openProva(item.link_meet)"
        >
          mdi-file-document
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary">
          Sem Aulas
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import LiveChat from "./LiveChat";
import aulaTeorico from "../../ws/aulasTeorica";
import CheckList from '../CheckList/CheckList';
import ColetaBiometria from "@/components/Teorico/coletaBiometria";
import aluno from "@/ws/aluno";

export default
{
  components:
    {
      ColetaBiometria,
      LiveChat,
      CheckList
    },
  data()
  {
    return {
      MOMENTO_INICIAL: 0,
      MOMENTO_ALEATORIO: 1,
      MOMENTO_FINAL: 2,
      randomImageTake: false,
      currentTime: 0,
      tempObjMeet: null,
      classId: null,
      studentId: null,
      live: false,
      closedAula: false,
      randomPhoto: false,
      isOpenProva: false,
      showModal: false,
      showModalCheck: false,
      classStart: true,
      choosedGesture: null,
      currentClass: null,
      loading: true,
      hasBioReturn: false,
      selectedStatus: false,
      status: [
        { status: 1, value: this.getStatus(1) },
        { status: 5, value: this.getStatus(5) },
        { status: 6, value: this.getStatus(6) },
        { status: 7, value: this.getStatus(7) },
        { status: 3, value: this.getStatus(3) },
        { status: 2, value: this.getStatus(2) },
        { status: 4, value: this.getStatus(4) },
      ],

      gestures: [
        { name: "Mostre um dedo com a sua mão esquerda", key: "one_finger" },
        { name: "Mostre dois dedos com a sua mão esquerda", key: "two_finger" },
        {
          name: "Mostre três dedos com a sua mão esquerda",
          key: "three_finger"
        },
        {
          name: "Mostre quatro dedos com a sua mão esquerda",
          key: "four_finger"
        },
        {
          name: "Mostre cinco dedos com a sua mão esquerda",
          key: "five_finger"
        }
      ],
      headers: [
        {
          text: "#ID",
          align: "start",
          sortable: false,
          value: "id"
        },
        { text: "Instrutor", value: "instrutor" },
        { text: "Sala", value: "sala" },
        { text: "Turma", value: "turma" },
        { text: "Data Hora", value: "data_hora" },
        { text: "Duração", value: "duracao" },
        {
          text: "Status",
          value: "status",
          filter: (value) => {
            if(this.selectedStatus == false) return true
            return this.selectedStatus.includes(this.getStatus(value));
          }
        },
        { text: "Prova Online",value: "provas", sortable: false},
        { text: "Aula Online", value: "actions", sortable: false },
      ],
      agendaAulas: [],
      linkMeet: "",
      jitsiDomain:"",
      jitsiExternalScript:"",
      jitsiJWT:"",
      randomImage: null,
      linkProva: null,
    };
  },
  created()
  {
    this.getAulaTeorico();
    this.selectedStatus = ["SALA ABERTA", "EM ANDAMENTO"];
  },

  mounted()
  {
    this.getCurrentClass();

    document.addEventListener('carregaInicio', () => {
      this.abrirModalBiometria(this.MOMENTO_INICIAL);
    });

    document.addEventListener('carregaModal', () => {
      this.abrirModalBiometria(this.MOMENTO_ALEATORIO);
    });

    document.addEventListener('closeBio', () => {
      this.fecharModalBiometria();
    });

    document.addEventListener('toLiveStream', () => {
      this.showModal = false;
      this.toLiveStream();
    });
  },

  methods:
    {
      isProva(url)
      {
        if(url != null) {
          if((url.match("docs.google") != null)||(url.match("forms.gle") != null)) {
            return true;
          }
        }
        return false;
      },

      openProva(url)
      {
        this.linkProva = url;
        this.isOpenProva = !this.isOpenProva;
      },

      closeProva()
      {
        this.isOpenProva = !this.isOpenProva;
      },

      isBlocked(item)
      {
        if((item.status != '4' && item.status != '5') && this.closedAula == true) {
          return true;
        }

        return false;
      },

      async getCurrentClass()
      {
        var response = "";
        try {
          response = await aluno.getLastClass(this.$store.getters.getAluno.cpf);
          if (response.data.last_class_id){
            this.currentClass = response.data.last_class_id;
            return response.data.last_class_id;
          }
        } catch (e) {
          console.log(e);
        }
        return false;
      },

      isCurrentClass(id)
      {
        return this.currentClass === id;
      },

      getColor(status)
      {
        if (status == 4) return "red";
        else if (status == 1) return "blue";
        else if (status == 2) return "green";
        else if (status == 5) return "orange";
        else return "red";
      },

      getStatus(status)
      {
        if (status == "4") return "EM ANDAMENTO";
        else if (status == "1") return "AGENDADA";
        else if (status == "2") return "AULA FINALIZADA";
        else if (status == "3") return "CANCELADA";
        else if (status == "5") return "SALA ABERTA";
        else if (status == "6") return "SALA FECHADA";
        else if (status == "7") return "SALA INDISPONÍVEL";

        else return "DESCONHECIDO";
      },

      async isValidTimeMa (item)
      {
        if (this.$store.getters.getCfc.uf == "MA" && !this.isCurrentClass(item.id)) {
          let response = await aulaTeorico.getTimeFromBegin(item.id)
            .catch(err => {
              console.info("Não foi possível buscar as informações nescessárias para determinar se o aluno está realizando a entrada de aula no tempo correto.");
              alert("Não foi possível verificar o status da aula para permitir a entrada, verifique a sua conexão com a internet.");
              return false;
            });

          let timeFromBegin = parseInt(response.data.message)
          let duracao = item.tempo_aula_teorico;
          let lostClasses = 0;

          if(timeFromBegin < 0) {
            alert("Não é possível entrar nesta aula no momento.")
            return false;
          }

          if (timeFromBegin > duracao) {
            lostClasses = Math.floor(timeFromBegin / duracao);
            alert(`Atenção, você perdeu ${lostClasses} aulas e está entrando na ${lostClasses + 1}ª aula.`);
          }

          timeFromBegin = timeFromBegin - (duracao * lostClasses);
          if (timeFromBegin > 15) {
            alert(`Atenção: O tempo de 15 minutos de atraso foi ultrapassado, você não terá presença na aula atual, a próxima aula inicia em ${duracao - timeFromBegin} minutos`);
            return false;
          }

          return true;
        } else {
          return true;
        }

        return false;
      },

      async showImageModal(item)
      {
        this.tempObjMeet = item;

        if ((this.tempObjMeet.status == '4' || this.tempObjMeet.status == '5' || this.isCurrentClass(item.id)) && await this.isValidTimeMa(item)) {
          this.loading = true;
          let response = await aulaTeorico.getNumeroBiometriasTiradas(this.tempObjMeet.id, this.$store.getters.getAluno.id, '0')
            .catch(erro => {
              console.error('Erro ao buscar biometrias: ', erro);
              alert("Houve um erro ao buscar as informações da chamada de video da aula, verifique sua conexão com a internet.");
              this.verificarSeFinalAula();
            })

          this.loading = false;

          if (response.data.biometrias > 0) {
            this.toLiveStream(item['link_meet']);
          } else {
            this.verificarSeFinalAula();
          }
        }
      },

      verificarSeFinalAula() {
        if(!this.closedAula) {
          this.showModalCheck = true;
        } else {
          this.abrirModalBiometria(this.MOMENTO_FINAL);
        }
      },

      abrirModalBiometria(momento = this.MOMENTO_INICIAL)
      {
        this.setMomento(momento);
        this.showModalCheck = false;
        this.choosedGesture = Math.floor(Math.random() * this.gestures.length);
        this.choosedGesture = this.gestures[this.choosedGesture];
        this.showModal = true;
      },

      fecharModalBiometria()
      {
        this.showModal = false;
        this.setMomento(this.MOMENTO_INICIAL)
      },

      closeLive()
      {
        this.getAulaTeorico();
        this.setMomento(this.MOMENTO_FINAL);
        let answer = window.confirm("Ao sair manualmente da sala, não será possivel retornar, tem certeza?",'sim', 'nao');
        if(answer) {
          this.setCurrentClass(0);
          clearTimeout(window.randomBio);
          this.live = !this.live;
          this.closedAula = true;
          this.abrirModalBiometria(this.MOMENTO_FINAL);
        }
      },

      async toLiveStream()
      {
        this.showModalCheck = false;

        if(this.setCurrentClass(this.tempObjMeet.id)){
          const response = await aulaTeorico.getJitsiParameters(this.tempObjMeet.id,this.$store.getters.getAluno.cpf)
            .catch(err => {
              console.error("Falha ao obter dados da chamada jitsi: ", err)
              alert("Não foi possível obter informações da chamada, favor verificar sua conexão com a internet.")
            });
          this.jitsiJWT = response.data.jwt
          this.jitsiDomain = response.data.domain
          this.jitsiExternalScript = response.data.externalApiJs
          this.linkMeet = response.data.roomName
          this.live = true;
        }
      },

      getAulaTeorico()
      {
        this.loading = true;

        if (!this.$store.getters.getAluno.cpf) {
          this.$router.push("/login", () => {});
        }

        aulaTeorico.findAll(this.$store.getters.getAluno.cpf).then(response => {
          var aulas = response.data;
          aulas.map((aula) => {
            if (aula.status == 4 || aula.status == 5) {
              aulaTeorico.getNumeroBiometriasTiradas(aula.id, this.$store.getters.getAluno.id, '2')
                .then(response => {
                  if (response.data.biometrias > 0) {
                    aula.status = 2;
                  }
                });
            }
            return aula;
          });
          this.agendaAulas = aulas;
          this.loading = false;
        });

      },

      async setCurrentClass(idAula)
      {
        var response = "";
        try {
          response = await aluno.setClass(this.$store.getters.getAluno.cpf, idAula);
          return(response.data.status);
        } catch (e) {
          console.log(e);
          return false;
        }
      },

      async setMomento(momento)
      {
        window.momento = momento;
      },

      update(){
        this.getAulaTeorico();
      },
    },
};
</script>
